import React from 'react';
import styled from 'styled-components';
import LogoBig from '../../assets/svgs/LogoBig';
import Share from '../../assets/images/share.svg';
import Add from '../../assets/images/add.svg';

const AddToHome = ({ className }) => {
    return (
        <div className={className}>
            <LogoBig isLoading={false} />
            <h2>افزودن اپلیکیشن پیشرو همیارسیستم</h2>
            <span>
                با این کار همواره می‌توانید به آسانی از خدمات همیارسیستم استفاده
                کنید
            </span>
            <div className="Instruction">
                <div>
                    ‫۱. دکمه Share را در نوار پایین کلیک کنید
                    <img src={Share} alt="share" />
                </div>
                <div>
                    ۲. گزینه Add to Home Screen را انتخاب کنید
                    <img src={Add} alt="add" />
                </div>
                <div>
                    ۳. در قسمت بالا روی Add کلیک کنید
                    <span>Add</span>
                </div>
            </div>
        </div>
    );
};

export default styled(AddToHome)`
    display: none;

    @media only screen and (max-width: 700px) {
        display: flex;
        flex-flow: column wrap;
        align-items: center;
        justify-content: center;
        direction: rtl;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 10001;
        background-color: rgb(19, 189, 239);

        h2 {
            margin-top: 20px;
            color: #fff;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 20px;
        }

        > span {
            color: #fff;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 40px;
        }

        .Instruction {
            width: 100%;
            max-width: 480px;

            > div {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 15px;
                color: #fff;
                font-size: 14px;
                font-weight: 300;
            }
        }
    }
`;
